module.exports = __webpack_public_path__ + "media/img/corporate/icon-e4c0edbb7aa3c6aa01d99f9aa988fb83.svg";